import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error not typed
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useQuery } from 'data-fetching-client';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// @ts-expect-error not typed
import GlobalContentModal from 'ContentEditorUI/components/modals/GlobalContentModal';
// @ts-expect-error not typed
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getOpenModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { selectCurrentInstance } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { GET_SMART_COPY_ARTICLE_WARNING } from '../../import/queries';
import { KB_MODAL_TYPES } from '../../types/ModalTypes';
import { usageTracker } from '../../utils/usageTracker';
import AutoSave from './AutoSave';
import LegacyScaffoldingContainer from './LegacyScaffoldingContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncSettingsModal = makeAsyncComponent(() => import( /* webpackChunkName: 'AsyncSettingsModal' */'../../settings/components/ArticleSettingsModal'));
const AsyncCreateLanguageVariationModal = makeAsyncComponent(() => import( /* webpackChunkName: 'LanguageVariationModal' */'../../settings/components/LanguageVariationModal'));
const AsyncCategoryModal = makeAsyncComponent(() => import( /* webpackChunkName: 'CreateCategoryModal' */'../../settings/components/CreateCategoryModal'));
const AsyncFeedbackSurvey = makeAsyncComponent(() => import( /* webpackChunkName: 'FeedbackSurvey' */'./FeedbackSurvey'));
const ExtraApplicationContainerComponents = () => {
  var _currentInstance$valu, _currentInstance$valu2;
  const openModal = useSelector(getOpenModal);
  const currentInstance = useSelector(selectCurrentInstance);
  const {
    data
  } = useQuery(GET_SMART_COPY_ARTICLE_WARNING, {
    variables: {
      articleId: currentInstance === null || currentInstance === void 0 || (_currentInstance$valu = currentInstance.values) === null || _currentInstance$valu === void 0 ? void 0 : _currentInstance$valu.hs_id
    },
    skip: !(currentInstance !== null && currentInstance !== void 0 && (_currentInstance$valu2 = currentInstance.values) !== null && _currentInstance$valu2 !== void 0 && _currentInstance$valu2.hs_id)
  });
  useEffect(() => {
    UsageTracker.init(usageTracker, 'knowledge-base-editor');
    usageTracker.track('pageView');
  }, []);
  useEffect(() => {
    if (!data) return;
    const id = 'importArticleWarning';
    if (data.importArticleWarning) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeArticleEditorUI.importArticles.alteredArticleNotification.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeArticleEditorUI.importArticles.alteredArticleNotification.title"
        }),
        type: 'warning',
        sticky: true,
        id
      });
    } else {
      FloatingAlertStore.removeAlert(id);
    }
    return () => FloatingAlertStore.removeAlert(id);
  }, [data]);
  const categoryModalIsOpen = [KB_MODAL_TYPES.CREATE_CATEGORY_MODAL, KB_MODAL_TYPES.CREATE_SUB_CATEGORY_MODAL, KB_MODAL_TYPES.EDIT_SUB_CATEGORY_MODAL, KB_MODAL_TYPES.EDIT_CATEGORY_MODAL
  //@ts-expect-error openModal can be null and still return false
  ].includes(openModal);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LegacyScaffoldingContainer, {}), /*#__PURE__*/_jsx(AutoSave, {}), /*#__PURE__*/_jsx(GlobalContentModal, {}), openModal === KB_MODAL_TYPES.SETTINGS_MODAL && /*#__PURE__*/_jsx(AsyncSettingsModal, {}), openModal === KB_MODAL_TYPES.CREATE_MLANG_VARIANT && /*#__PURE__*/_jsx(AsyncCreateLanguageVariationModal, {}), categoryModalIsOpen && /*#__PURE__*/_jsx(AsyncCategoryModal, {
      isSubCategory: openModal === KB_MODAL_TYPES.CREATE_SUB_CATEGORY_MODAL || openModal === KB_MODAL_TYPES.EDIT_SUB_CATEGORY_MODAL,
      isEditing: openModal === KB_MODAL_TYPES.EDIT_CATEGORY_MODAL || openModal === KB_MODAL_TYPES.EDIT_SUB_CATEGORY_MODAL
    }), /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(AsyncFeedbackSurvey, {})]
  });
};
export default ExtraApplicationContainerComponents;